// ** Navigation imports
import apps from './apps'

// ** Merge & Export

let values = [...apps]

export default values
